import {menuApi} from "@/api";

const SET_MENU = "impulse/menu/SET_MENU";
const ADD_ITEM_MENU = "impulse/menu/ADD_ITEM_MENU";
const DELETE_ITEM_MENU = "impulse/menu/DELETE_ITEM_MENU";
const UPDATE_ITEM_MENU_URL = "impulse/menu/UPDATE_ITEM_MENU_URL";

const SET_MENU_EXPANDED = "impulse/menu/SET_MENU_EXPANDED";
const SET_MENU_MINIMIZED = "impulse/menu/SET_MENU_MINIMIZED";

const initialState = {
  items: [],
  isMinimized: false
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU: {
      return {
        ...state,
        items: action.menu
      };
    }
    case ADD_ITEM_MENU: {
      return {
        ...state,
        items: state.items.map(item => {
          if (item?.folder)
            return item;
          return {
            ...item,
            items: [
              ...item.items,
              action.newItem
            ]
          }
        })
      };
    }
    case UPDATE_ITEM_MENU_URL:
      return {
        ...state,
        items: state.items.map((folder) => {
          return {
            ...folder,
            items: folder.items.map(menuItem =>
              menuItem.id === action.id ? { ...menuItem, url: action.url } : menuItem
            )
          }
        })
      }
    case DELETE_ITEM_MENU:
      return {
        ...state,
        items: state.items.map((folder) => {
          return {
            ...folder,
            items: folder.items.filter(menuItem => menuItem.id != action.id)
          }
        })
      }
    case SET_MENU_EXPANDED:
      return {
        ...state,
        isMinimized: false,
      }
    case SET_MENU_MINIMIZED:
      return {
        ...state,
        isMinimized: true,
      }
    default:
      return state;
  }
};

export const actionSetMenu = (menu) => ({
  type: SET_MENU,
  menu,
});

export const actionAddItemMenu = (newItem) => ({
  type: ADD_ITEM_MENU,
  newItem,
});

export const actionUpdateMenuItemUrl = (id, url) => ({
  type: UPDATE_ITEM_MENU_URL,
  id,
  url
});

export const actionDeleteMenuItem = (id) => ({
  type: DELETE_ITEM_MENU,
  id
});

export const fetchMenu = () => (dispatch) => {
  
  const selectedLanguage = localStorage.getItem('selectedLanguage');
  
  menuApi
    .getMenu(selectedLanguage, 'basic')
    .then(({data}) => dispatch(actionSetMenu(data.map((el)=>({...el, items: el.items.filter(elem => elem.is_active)})))))
};

export const actionExpandedMenu = () => ({
  type: SET_MENU_EXPANDED
});

export const actionMinimizedMenu = () => ({
  type: SET_MENU_MINIMIZED
});

export default menuReducer;
